<h4 class="m-0 fw-bold">{{ result.companyName }}</h4>
<p class="mb-0">{{ result.parentCompany }}</p>
<div class="company-status-fields">
    <!-- Inactive Flag -->
    @if (result.status === 'Inactive') {
        <img src="/images/inactive.jpg" alt="Inactive" class="status-img" />
    }
    <!-- Active Pending Flag -->
    @if (result.status === 'Active (Pending)') {
        <img src="/images/active-pending.jpg" alt="Active (Pending)" class="status-img" />
    }
    <!-- Sold Flag -->
    @if (result.soldDate) {
        <img src="/images/sold.png" alt="Sold" class="status-img" />
    }
</div>
